/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";
import { Button, IButtonProps } from "../../core";

import "./FieldInnerButton.scss";

export interface IFieldInnerButtonProps extends IButtonProps {
	className?: string;
}

export const FieldInnerButton: React.FC<IFieldInnerButtonProps> = ({ className, ...props }) => {
	const baseClass = BEM("edt-field-inner-button");

	if (className) {
		baseClass.add(className);
	}

	return <Button className={baseClass.toClassName()} {...props} />;
};
